<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomDate
          :fullWidth="true"
          label="Дата отгрузки"
          :value="this.formData.date_shipping_plan"
          @change_date="(value) => onChange('date_shipping_plan', value)"
          required="true"
        />
      </div>

      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomDate from "@/components/form/CustomDate";

export default {
  name: "prov-req-ship-from-warehouse",
  components: { CustomDate, CustomModalFooter },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        date_shipping_plan: this.data?.date_shipping_plan || '',
        provider_request_id: this.data.provider_request_id || ''
      },
      warehouseOptions: [],
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
}
</script>
